import { render, staticRenderFns } from "./CustTagView.vue?vue&type=template&id=59021e8b&scoped=true"
import script from "./CustTagView.vue?vue&type=script&lang=js"
export * from "./CustTagView.vue?vue&type=script&lang=js"
import style0 from "./CustTagView.vue?vue&type=style&index=0&id=59021e8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59021e8b",
  null
  
)

export default component.exports